import React, { useContext } from 'react'
import { NotificationProvider } from './notification-provider'

interface INotificationError {
  data: string
  status: number
  statusText: string
  headers: object
  config: object
  request: object
}

const ErrorBar = ({ error: { message } }: { error: { message: string; updatedAt: number } }) => {
  const notification: any = useContext(NotificationProvider)
  if (message) {
    const objMessage: INotificationError = JSON.parse(JSON.stringify(message))
    if (objMessage.data) {
      notification.addNotification({
        title: objMessage.statusText,
        level: 'error',
        message: objMessage.data
      })
    } else {
      const newObjMessage: { error: string; riderId: string } = JSON.parse(JSON.stringify(message))
      // changed text message logic, so existing notification format will not be affected
      const notificationMessage: any =
        typeof objMessage === 'object' && objMessage !== null && objMessage.hasOwnProperty('error')
          ? newObjMessage.error
          : message

      notification.addNotification({
        title: 'Error',
        level: 'error',
        message: JSON.stringify(notificationMessage)
      })
    }
  }

  return null
}

export default ErrorBar



// WEBPACK FOOTER //
// ./src/components/ui/ErrorBar.tsx